// Should the sign-in carry a guest's in-progress tips to the account?
//
// Pulled out of App.js so the decision can be tested on its own — it is the part
// that decides whether a request happens at all, on a path every sign-in runs.
//
// `state` is the account's own result for this word (null when it has none yet).
export function fireCarry(localBoard, state) {
  const already = (state && state.attempts) || 0;
  if (!localBoard || !localBoard.length || localBoard.length <= already) return false;
  // A finished game's count is settled. The server refuses this too; not asking
  // is one fewer pointless request.
  if (state && state.status === "guessed") return false;
  return true;
}
